"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Dom = require("../utils/Dom");

var _underscore = require("../utils/underscore");

var _passthroughProps = _interopRequireDefault(require("../utils/propTypes/passthroughProps"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Selectors = require("../constants/Selectors");

var _react = _interopRequireWildcard(require("react"));

var _Functions = require("../core/Functions");

var _ReactNodes = require("../core/ReactNodes");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _decorators = require("../utils/propTypes/decorators");

var _UIAbstractDropdown = _interopRequireDefault(require("./abstract/UIAbstractDropdown"));

var _UIAbstractDropdownWithSearchbox = _interopRequireDefault(require("./abstract/UIAbstractDropdownWithSearchbox"));

var _UIPopover = _interopRequireDefault(require("../tooltip/UIPopover"));

var _PlacementConstants = require("../tooltip/PlacementConstants");

var USE_CLASSES = {
  list: 'private-dropdown--list',
  unstyled: ''
};

var UIDropdown =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIDropdown, _PureComponent);

  function UIDropdown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIDropdown);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIDropdown).call(this, props));
    _this.state = {
      hasSearchbox: false
    };
    _this._id = "dropdown-menu-" + (0, _underscore.uniqueId)();
    _this.menuRefCallback = _this.menuRefCallback.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMenuClick = _this.handleMenuClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenComplete = _this.handleOpenComplete.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSearchChange = _this.handleSearchChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderContent = _this.renderContent.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIDropdown, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Only autofocus when `open` prop goes from false => true
      if (!this.props.open && nextProps.open) {
        this._enableAutofocus = true;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkForSearchbox(); // Reposition the Tether, as the results list may have changed height.

      if (this._dropdownRef) {
        this._dropdownRef.reposition();
      }
    }
  }, {
    key: "checkForSearchbox",
    value: function checkForSearchbox() {
      // Check if we have a searchbox, as we may need to make the arrow color match.
      if (this._menuEl && document.body.contains(this._menuEl)) {
        var hasSearchbox = !!this._menuEl.querySelector('.private-typeahead:not(.hide-search)');

        if (this.state.hasSearchbox !== hasSearchbox) {
          this.setState({
            hasSearchbox: hasSearchbox
          });
        }
      }
    }
  }, {
    key: "menuRefCallback",
    value: function menuRefCallback(ref) {
      this._menuEl = ref;
      if (ref) this.checkForSearchbox();
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick(evt) {
      var _this$props = this.props,
          closeOnMenuClick = _this$props.closeOnMenuClick,
          onOpenChange = _this$props.onOpenChange;

      if (closeOnMenuClick) {
        var target = evt.target;
        var iterableTarget = target;
        var menu = document.getElementById(this._id);
        if (!menu || !menu.contains(target)) return; // Portals! #6595

        while (iterableTarget && !(0, _Dom.elementHasClass)(iterableTarget, 'private-dropdown') && iterableTarget.getAttribute('data-component-name') !== 'UIFileButton') {
          // Only close when clicking a `button` or `a` tag!
          if (['BUTTON', 'A'].includes(iterableTarget.nodeName) && !iterableTarget.disabled) {
            onOpenChange((0, _SyntheticEvent.default)(false));
            return;
          }

          iterableTarget = iterableTarget.parentElement;
        }
      }
    }
  }, {
    key: "handleOpenComplete",
    value: function handleOpenComplete() {
      var onOpenComplete = this.props.onOpenComplete;
      (0, _Functions.callIfPossible)(onOpenComplete);

      if (this._typeaheadRef && this._enableAutofocus) {
        (0, _Functions.callIfPossible)(this._typeaheadRef.focus);
        this._enableAutofocus = false;
      }
    }
  }, {
    key: "handleSearchChange",
    value: function handleSearchChange() {
      this.forceUpdate(); // Reposition the Tether after the search results flush to the DOM
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(evt) {
      var key = evt.key;
      var _this$props2 = this.props,
          onOpenChange = _this$props2.onOpenChange,
          open = _this$props2.open,
          use = _this$props2.use;
      if (!open) return;

      if (this.state.hasSearchbox) {
        if (key === 'Enter') {
          onOpenChange((0, _SyntheticEvent.default)(false));
        }

        evt.stopPropagation();
        return;
      } // Move the focus to the next/prev menu item (<li>).


      if (use !== 'unstyled' && (key === 'ArrowDown' || key === 'ArrowUp')) {
        var menu = document.getElementById(this._id);
        if (!menu) return;
        var allMenuItems = menu.querySelectorAll('li');
        if (allMenuItems.length === 0) return;
        var currentMenuItem = (0, _Dom.closest)(document.activeElement, 'li');
        var nextMenuItem = key === 'ArrowDown' ? currentMenuItem && currentMenuItem.nextSibling || allMenuItems[0] : currentMenuItem && currentMenuItem.previousSibling || (0, _underscore.last)(allMenuItems);

        while (nextMenuItem !== currentMenuItem) {
          var focusTarget = nextMenuItem.querySelector(_Selectors.FOCUSABLE);

          if (focusTarget) {
            evt.preventDefault();
            focusTarget.focus();
            break;
          }

          nextMenuItem = key === 'ArrowDown' ? nextMenuItem.nextSibling || allMenuItems[0] : nextMenuItem.previousSibling || (0, _underscore.last)(allMenuItems);
        }

        evt.stopPropagation();
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          Content = _this$props3.Content;
      var hasSearchbox = this.state.hasSearchbox;
      var mutatedChildren = children;

      if (hasSearchbox && !Content) {
        mutatedChildren = _react.Children.map(children, function (child) {
          if ((0, _ReactNodes.nodeDisplayNameMatches)(child, /UITypeahead|UIGroupedTypeahead/)) {
            return _react.default.cloneElement(child, {
              onSearchChange: (0, _Functions.memoizedSequence)(child.props.onSearchChange, _this2.handleSearchChange),
              ref: function ref(typeaheadRef) {
                _this2._typeaheadRef = typeaheadRef;
              }
            });
          }

          return child;
        });
      }

      return _react.default.createElement("div", {
        id: this._id,
        onClick: this.handleMenuClick,
        ref: this.menuRefCallback,
        role: "presentation"
      }, Content ? _react.default.createElement(Content, null) : mutatedChildren);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          autoPlacement = _this$props4.autoPlacement,
          buttonClassName = _this$props4.buttonClassName,
          buttonText = _this$props4.buttonText,
          buttonUse = _this$props4.buttonUse,
          children = _this$props4.children,
          className = _this$props4.className,
          __closeOnMenuClick = _this$props4.closeOnMenuClick,
          __Content = _this$props4.Content,
          dropdownClassName = _this$props4.dropdownClassName,
          locked = _this$props4.locked,
          iconName = _this$props4.iconName,
          popoverProps = _this$props4.popoverProps,
          use = _this$props4.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props4, ["autoPlacement", "buttonClassName", "buttonText", "buttonUse", "children", "className", "closeOnMenuClick", "Content", "dropdownClassName", "locked", "iconName", "popoverProps", "use"]);

      var containsFooter = _react.Children.toArray(children).some(function (child) {
        return (0, _ReactNodes.nodeDisplayNameMatches)(child, /UIDropdownFooter/);
      });

      var computedDropdownClassName = (0, _classNames.default)(className, dropdownClassName, USE_CLASSES[use], {
        'p-y-0': containsFooter
      });
      var defaultIcon = buttonText ? undefined : 'settings';
      return _react.default.createElement(_UIAbstractDropdownWithSearchbox.default, (0, _extends2.default)({}, rest, {
        autoPlacement: autoPlacement,
        buttonText: buttonText,
        buttonUse: buttonUse,
        className: buttonClassName,
        Content: this.renderContent,
        dropdownClassName: computedDropdownClassName,
        hasSearchbox: this.state.hasSearchbox,
        iconName: iconName !== undefined ? iconName : defaultIcon,
        locked: locked,
        onOpenComplete: this.handleOpenComplete,
        onKeyDown: this.handleKeyDown,
        popoverProps: popoverProps,
        ref: function ref(_ref) {
          _this3._dropdownRef = _ref;
        }
      }));
    }
  }]);
  return UIDropdown;
}(_react.PureComponent);

UIDropdown.propTypes = (0, _extends2.default)({}, _UIAbstractDropdown.default.propTypes, {
  arrowColor: (0, _decorators.hidden)(_UIAbstractDropdown.default.propTypes.arrowColor),
  buttonClassName: _react.PropTypes.string,
  buttonText: _UIAbstractDropdown.default.propTypes.buttonText,
  children: _UIAbstractDropdown.default.propTypes.children,
  closeOnMenuClick: _react.PropTypes.bool.isRequired,
  iconName: _UIAbstractDropdown.default.propTypes.iconName,
  locked: _UIAbstractDropdown.default.propTypes.locked,
  onOpenChange: _UIAbstractDropdown.default.propTypes.onOpenChange,
  open: _UIAbstractDropdown.default.propTypes.open,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
  popoverProps: (0, _passthroughProps.default)(_UIPopover.default),
  use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired
});
UIDropdown.defaultProps = (0, _extends2.default)({}, _UIAbstractDropdown.default.defaultProps, {
  buttonUse: 'tertiary-light',
  closeOnMenuClick: true,
  menuWidth: 'auto',
  pinToConstraint: true,
  use: 'list'
});
UIDropdown.displayName = 'UIDropdown';

var _default = (0, _Controllable.default)(UIDropdown, ['open']);

exports.default = _default;
module.exports = exports.default;